import { useState } from "react";

export default function SearchBar({ onSearchF }){    
    const [search, setSearch] = useState("");

    const getStringSearch = (e) => {
        setSearch(e.target.value);
        if (e.target.value.length === 0) {
			onSearchF('', true);
		}
    }

    const clickSearch = async () => {
        onSearchF(search).catch(null);
    }

    return (
        <div className="searchbar-container">
			<div className="searchbar">
				<input placeholder="Buscar pokemon..." onChange={getStringSearch} />
			</div>
			<div className="searchbar-btn">
				<button onClick={clickSearch}>Buscar</button>
			</div>
		</div>
    );
}